import React from "react";
import Section_name from "../ipillion/Section_name";
import Image from "next/image";
import { useTranslations } from "next-intl";
import Number_one from "../assets/ez_credit/Number_one";
import Number_two from "../assets/ez_credit/Number_two";
import Number_three from "../assets/ez_credit/Number_three";
const How_work = ({}) => {
  const list = [1, 2, 3];
  const t = useTranslations("ez_credit.how_ez");
  const icons = {
    one: <Number_one />,
    two: <Number_two />,
    three: <Number_three />,
  };
  return (
    <div>
      <Section_name
        name={t("header")}
        color={"#C29D3E"}
        margin={"mt-[88px] "}
      />
      <div className="flex lg:flex-row flex-col  lg:justify-between justify-center">
        <div>
          {/* <p className="max-w-[573px] relative text-[18px] w-[90%] lg:mb-5 mb-20 h-[86px] leading-[26px] font-[400]">
            {t("title")}
          </p> */}
          <div className="py-3">
            {list.map((element, index) => {
              return (
                <div className="flex flex-col lg:flex-row mb-[32px] mt-[16px]">
                  <div>
                    <label className="inline-block w-[98px]">
                      {icons[t(`list.${index}.icon`)]}
                    </label>
                  </div>
                  <div className="max-w-[473px] w-[100%]">
                    <p className="text-[#C29D3E] leading-[18px] text-[18px] font-[400]">
                      {t(`list.${index}.title`)}
                    </p>
                    <p className="mt-[10px] lg:leading-[18px] leading-[20px] lg:text-[18px] text-[16px] lg:font-[400] font-[700]">
                      {t(`list.${index}.descrption`)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="relative lg:w-[518.56px] lg:h-[449.32px] w-[280px] h-[312.06px]">
          <Image src="/ez_credit/calculator.png" layout="fill" />
        </div>
      </div>
    </div>
  );
};

export default How_work;
